module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1229.023b7f1e.png";